import React, {  useState } from 'react';
import {  useSelector } from 'react-redux';
import { DotsIcon } from '../../../svg'
import Menu from './Menu';
import { CreateGroup } from './createGroup';

export default function SidebarHeader({ onCollapse }) {

    const {user} = useSelector((state)=>state.user)
    const [showMenu,setShowMenu] = useState(false);
    const [showCreateGroup,setShowCreateGroup] = useState(false);
        return (
            <>
            <div className='h-[50px] dark:bg-dark_bg_2 flex items-center p16'>
                <div className='w-full flex items-center justify-between'>
                    <button className ="btn">
                        <img src={user.picture} alt={user.name}
                            className='w-full h-full rounded-full object-cover'
                        />
                    </button>

                    <ul className="flex items-center gap-x-2 5">
                        {onCollapse && (
                        <li>
                            <button className="btn text-dark_svg_1 rtl:rotate-180" onClick={onCollapse} title="طي الشريط الجانبي">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M15 18l-6-6 6-6" />
                                </svg>
                            </button>
                        </li>
                        )}
                        <li className='relative' onClick={()=> setShowMenu((prev)=>!prev)}>
                            <button className={`btn ${showMenu ? "bg-dark_hover_1":""}`}>
                                <DotsIcon className="dark:fill-dark_svg_1" />
                            </button>
                            {
                                showMenu?<Menu setShowCreateGroup={setShowCreateGroup}/>:null
                            }
                        </li>
                    </ul>


                </div>
            </div>
            {showCreateGroup &&
            <CreateGroup setShowCreateGroup={setShowCreateGroup}/> }
            </>

        );

}

